import { configureStore } from "@reduxjs/toolkit";
import accessTokenSliceReducer from "./reducers/accessTokenSlice";
import idTokenSliceReducer from "./reducers/idTokenSlice";

export default configureStore({
  reducer: {
    accessToken: accessTokenSliceReducer,
    idToken: idTokenSliceReducer,
  },
});
